module.exports = __webpack_public_path__ + "static/media/bulb_2.8b2954b6.png";